export default "__VITE_ASSET__CH5Tyvry__"